//popup-edit.ts
import { AddTimesheetService } from "@/services/add-timesheet/add-timesheet.service";
import { ProjectService } from "@/services/project/project.service";
import { SessionTimeoutService } from "@/services/session-timeout/session-timeout.service";
import { Component, HostListener, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { MainTimesheet } from "src/app/class/main-timesheet";
import { Timesheet } from "src/app/class/timesheet";
import Swal from "sweetalert2";

import { VerifyTimesheetViewService } from "@/services/verify-timesheet/verify-timesheet-view.service";
import { forkJoin } from "rxjs";
import { map } from "rxjs/operators";

export interface Expense {
  siteId: number;
  siteName: string;
  siteCost: string | number;
}

export class Project {
  id: number;
  projectCode: string;
  projectName: string;
  locationed: string;
  managerId: any;
  managerFirstname: string;
  managerLastname: string;
  managerNicknameTh: string;
  startDate: number;
  endDate: Date;
  roleId: any;
  createdDate: any;
  createdBy: string;
  updatedDate: Date;
  updatedBy: string;
  isDelete: string;
  timesheetModelList: any;
  countmanday: string;
  msProjectSites: Expense[];
  manday: number;
  description: string;
  isSiteActive: string
}

@Component({
  selector: "app-popup-edit",
  templateUrl: "./popup-edit.component.html",
  styleUrls: ["./popup-edit.component.scss"],
})
export class PopupEditComponent implements OnInit {
  @Input() travel_expeneses: any;
  @Input() propModal: any;
  @Input() timeId: any;

  tmpDate: any;
  tmpTimeTo: any;
  tmpTimeFrom: any;
  isOnsite: boolean;
  selectedSiteId: number | null = null;

  id = localStorage.getItem("UserId");
  userid: any = +this.id;

  checkMandayProject: any[];
projectRemainingManday: any[] = [];

  cost: any;
  maintimesheetId: number;
  timesheet = new Timesheet();
  projects: Array<Project> = [];
  allProjects: Array<Project> = [];
  refProject: any = [];
  project_Array = [];
  roleId = localStorage.getItem("roleId");
  role: number = +this.roleId;
  sumWorkingHours: number = 0;
  overlappingTimeRange: string = ''; 
  
  // ตัวแปรสำหรับตรวจสอบเวลาทับซ้อน
  isTimeOverlap: boolean = false;

  mainTimesheets = new MainTimesheet();

  listStartTime = [
    "00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11",
    "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23",
  ];

  listEndTime = ["00", "15", "30", "45"];

  searchStartTime: any;
  searchEndTime: any;

  houreStart = "00";
  minuteEnd = "00";

  houreStartEnd = "00";
  minuteEndEnd = "00";
  elf: any;
  selectedProjectCost: number;
  selectedProjectSites: Expense[] = [];
  isLeaveEntry: boolean = false;

  constructor(
    public modalService: NgbModal,
    private _route: Router,
    private _service: AddTimesheetService,
    private _activatedRoute: ActivatedRoute,
    private projectService: ProjectService,
    private timesheetService: AddTimesheetService,
    private sessionTimeoutService: SessionTimeoutService,
    private verifyTimesheetViewService: VerifyTimesheetViewService
  ) {}

  
  closeModal: string;

  ngAfterViewInit(): void {
  this.resizeAllTextareas();
}

autoResizeTextarea(event: any): void {
  const textarea = event.target;
  textarea.style.height = 'auto';
  textarea.style.height = textarea.scrollHeight + 'px';
}

resizeAllTextareas(): void {
  setTimeout(() => {
    const textareas = document.querySelectorAll('textarea');
    textareas.forEach((textarea: any) => {
      textarea.style.height = 'auto';
      textarea.style.height = textarea.scrollHeight + 'px';
    });
  }, 100);
}

  checkTimeOverlap() {
  // ตรวจสอบข้อมูลที่จำเป็น
  if (!this.tmpDate || !this.tmpTimeFrom || !this.tmpTimeTo) {
    console.log('Missing required data:', {
      tmpDate: this.tmpDate,
      tmpTimeFrom: this.tmpTimeFrom,
      tmpTimeTo: this.tmpTimeTo
    });
    return;
  }

  if (!this.maintimesheetId) {
    console.log('Missing maintimesheetId');
    return;
  }

  // แปลงวันที่เป็น YYYY-MM-DD format (ลบ 1 วันก่อนส่งไป service)
  const dateStr = moment(this.tmpDate).subtract(1, "day").format("YYYY-MM-DD");

  console.log('Checking overlap for:', {
    maintimesheetId: this.maintimesheetId,
    dateStr,
    timeFrom: this.tmpTimeFrom,
    timeTo: this.tmpTimeTo
  });

  this._service.findTimesheetByDate(this.maintimesheetId, dateStr).subscribe(
    (timesheets: Timesheet[]) => {
      console.log('Timesheets found:', timesheets);
      
      if (!timesheets || timesheets.length === 0) {
        console.log('No timesheets found for this date');
        this.isTimeOverlap = false;
        this.overlappingTimeRange = '';
        return;
      }

      this.isTimeOverlap = false;
      this.overlappingTimeRange = '';

      const currentStart = this.timeToMinutes(this.tmpTimeFrom);
      const currentEnd = this.timeToMinutes(this.tmpTimeTo);

      // เก็บช่วงเวลาที่ซ้ำทั้งหมด
      let overlapStartMin: number | null = null;
      let overlapEndMin: number | null = null;

      for (let ts of timesheets) {
        // ข้ามถ้าเป็น timesheet ตัวเดียวกัน
        if (ts.id === this.timesheet.id) {
          continue;
        }

        const existingStart = this.timeToMinutes(ts.timeFrom);
        const existingEnd = this.timeToMinutes(ts.timeTo);

        console.log('Comparing times:', {
          current: `${currentStart}-${currentEnd}`,
          existing: `${existingStart}-${existingEnd}`,
          projectId: ts.projectId,
          timesheetId: ts.id
        });

        // ตรวจสอบว่ามีการทับซ้อนหรือไม่
        if (this.isOverlapping(currentStart, currentEnd, existingStart, existingEnd)) {
          this.isTimeOverlap = true;
          
          // คำนวณช่วงเวลาที่ซ้ำจริงๆ
          // Overlap Start = max(currentStart, existingStart)
          // Overlap End = min(currentEnd, existingEnd)
          const thisOverlapStart = Math.max(currentStart, existingStart);
          const thisOverlapEnd = Math.min(currentEnd, existingEnd);
          
          // รวมช่วงเวลาที่ซ้ำ (เอาช่วงที่กว้างที่สุด)
          if (overlapStartMin === null || thisOverlapStart < overlapStartMin) {
            overlapStartMin = thisOverlapStart;
          }
          if (overlapEndMin === null || thisOverlapEnd > overlapEndMin) {
            overlapEndMin = thisOverlapEnd;
          }
        }
      }

      // แปลง minutes กลับเป็น HH:mm format
      if (this.isTimeOverlap && overlapStartMin !== null && overlapEndMin !== null) {
        const startHour = Math.floor(overlapStartMin / 60).toString().padStart(2, '0');
        const startMin = (overlapStartMin % 60).toString().padStart(2, '0');
        const endHour = Math.floor(overlapEndMin / 60).toString().padStart(2, '0');
        const endMin = (overlapEndMin % 60).toString().padStart(2, '0');
        
        this.overlappingTimeRange = `${startHour}:${startMin}-${endHour}:${endMin}`;
        console.log('Overlap detected:', this.overlappingTimeRange);
      }
    },
    (error) => {
      console.log("Error checking time overlap:", error);
      this.isTimeOverlap = false;
      this.overlappingTimeRange = '';
    }
  );
}

/**
 * แปลงเวลาเป็น minutes สำหรับเปรียบเทียบ
 */
timeToMinutes(time: any): number {
  let timeStr: string;
  
  if (typeof time === 'string') {
    // รองรับทั้ง HH:mm และ HH:mm:ss format
    timeStr = time.split(':').slice(0, 2).join(':');
  } else if (time instanceof Date) {
    timeStr = moment(time).format("HH:mm");
  } else {
    return 0;
  }

  const [hours, minutes] = timeStr.split(':').map(Number);
  return hours * 60 + minutes;
}

/**
 * ตรวจสอบว่าช่วงเวลาทับซ้อนกันหรือไม่
 */
isOverlapping(start1: number, end1: number, start2: number, end2: number): boolean {
  return (start1 < end2) && (end1 > start2);
}

 

  saveAll(modal: any) {
    modal.close("Back click");
    this.tmpTimeFrom = this.houreStart + ":" + this.minuteEnd;
    this.searchStartTime = this.tmpTimeFrom;
    
    // เรียก calWorkingHrs() ซึ่งจะเรียก checkTimeOverlap() ด้วย
    this.calWorkingHrs();
  }

  saveAllEndTime(modal: any) {
    modal.close("Back click");
    this.tmpTimeTo = this.houreStartEnd + ":" + this.minuteEndEnd;
    this.searchEndTime = this.tmpTimeTo;
    
    // เรียก calWorkingHrs() ซึ่งจะเรียก checkTimeOverlap() ด้วย
    this.calWorkingHrs();
  }

  ngOnInit(): void {
    this.getProjectAll();
    this.sessionTimeoutService.ResetTime();
  }

  @HostListener("mousemove")
  @HostListener("touchstart")
  ResetTime() {
    this.sessionTimeoutService.ResetTime();
  }

  getCost(id: any) {
    const projectId = Number(id);
    const projectCost = this.projects.find((item) => item.id === projectId);

    if (!this.timesheet.cost) {
      this.timesheet.cost = projectCost.msProjectSites && projectCost.msProjectSites.length > 0 
        ? Number(projectCost.msProjectSites[0].siteCost) || 0 
        : 0;
    }
  }

 

  getProjectAll() {
    this.projectService.getProjectAll().subscribe((data) => {
      this.allProjects = data;

      this.projects = data.filter(project => {
        return !(project.projectCode && /^L(10|[1-9])$/.test(project.projectCode));
      });

      this.getData();
    });
  }

  getRefProject(timesheet: any) {
    this.timesheetService
      .getSameDateTimesheets(
        timesheet.employeeId,
        timesheet.transDate,
        timesheet.id
      )
      .subscribe((data) => {
        this.refProject = data;
        console.log("ProjectArray", this.refProject);
        this.checkWorkingHrs();
      });
  }

  CloseMOdel(modal: any) {
    modal.close("Back click");
  }

  /**
   * Calculate working hours and check for time overlap
   */
  calWorkingHrs() {
    this.timesheet.timeFrom = moment(this.tmpTimeFrom, "HH:mm").toDate();
    this.timesheet.timeTo = moment(this.tmpTimeTo, "HH:mm").toDate();
    
    this.timesheet.workingHours =
      (this.timesheet.timeTo.getTime() - this.timesheet.timeFrom.getTime()) / 3600000;

    this.timesheet.workingHours = Number(this.timesheet.workingHours.toFixed(2));
    
    if (this.timesheet.isBreak == true) {
      this.timesheet.workingHours = this.timesheet.workingHours - 1;
    } else {
      this.timesheet.isBreak = false;
    }
    
    // ตรวจสอบเวลาทับซ้อนเมื่อมีการเปลี่ยนแปลงเวลา
    this.checkTimeOverlap();
    this.checkWorkingHrs();
  }



  /**
   * ดึงชื่อโปรเจคจาก ID
   */
  getProjectNameById(projectId: number): string {
    const project = this.allProjects.find(p => p.id === projectId);
    return project ? project.projectName : 'Unknown Project';
  }

  checkWorkingHrs() {
    this.sumWorkingHours = 0;
    if (this.refProject) {
      this.refProject.forEach((element: any) => {
        this.sumWorkingHours += element.workingHours;
      });
    }

    this.sumWorkingHours += this.timesheet.workingHours;
    if (this.sumWorkingHours >= 8) {
      return true;
    }
  }

updateTimesheet() {
  this.timesheet.timeFrom = moment(this.tmpTimeFrom, "HH:mm")
    .subtract(-7, "hour")
    .toDate();
  this.timesheet.timeTo = moment(this.tmpTimeTo, "HH:mm")
    .subtract(-7, "hour")
    .toDate();

  Swal.fire({
    target: document.getElementById("form-modal"),
    title: "Do you want to save the changes?",
    showCancelButton: true,
    confirmButtonText: "Save",
  }).then((result) => {
    if (result.isConfirmed) {
      // ตรวจสอบ working hours
      if (this.timesheet.workingHours <= 0) {
        Swal.fire({
          target: document.getElementById("form-modal"),
          title: "Error",
          text: "Working hours must be greater than 0",
          icon: "error",
          confirmButtonText: "OK",
        });
        return;
      }

      // ตรวจสอบเวลาทับซ้อนก่อนบันทึกโดยใช้ maintimesheetId
      const dateStr = moment(this.tmpDate).subtract(1, "day").format("YYYY-MM-DD");

      this._service.findTimesheetByDate(this.maintimesheetId, dateStr).subscribe(
        (timesheets: Timesheet[]) => {
          this.isTimeOverlap = false;
          const currentStart = this.timeToMinutes(this.tmpTimeFrom);
          const currentEnd = this.timeToMinutes(this.tmpTimeTo);

          // ค้นหา timesheet ที่ทับซ้อน
          let overlappingTimesheet: Timesheet | null = null;
          for (let ts of timesheets) {
            if (ts.id === this.timesheet.id) continue;
            
            const existingStart = this.timeToMinutes(ts.timeFrom);
            const existingEnd = this.timeToMinutes(ts.timeTo);

            if (this.isOverlapping(currentStart, currentEnd, existingStart, existingEnd)) {
              this.isTimeOverlap = true;
              overlappingTimesheet = ts;
              break;
            }
          }

          // ถ้าเวลาทับซ้อน แสดงคำเตือนและไม่บันทึก
          if (this.isTimeOverlap && overlappingTimesheet) {
            return;
          }

          // ✅ เพิ่ม: ตรวจสอบ Manday ก่อนบันทึก
          this.checkMandayBeforeUpdate();
        },
        (error) => {
          console.log("Error checking time overlap:", error);
          Swal.fire({
            target: document.getElementById("form-modal"),
            title: "Error",
            text: "ไม่สามารถตรวจสอบเวลาทับซ้อนได้",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      );
    }
    return false;
  });
}

private checkMandayBeforeUpdate() {
  console.log('=== checkMandayBeforeUpdate START ===');
  
  // 1. ดึง main timesheet เพื่อหา month และ year
  this.verifyTimesheetViewService.findMainTimesheetById(this.maintimesheetId).subscribe(
    mainTimesheet => {
      console.log('Main Timesheet:', mainTimesheet);
      
      const month = mainTimesheet.month;
      const year = mainTimesheet.year;
      
      // 2. สร้าง date array ของเดือนนั้นทั้งเดือน
      const daysInMonth = moment(`${year}-${month}`, 'YYYY-M').daysInMonth();
      const allDatesInMonth = Array.from({ length: daysInMonth }, (_, i) => {
        return moment(`${year}-${month}-${i + 1}`, 'YYYY-M-D').format('YYYY-MM-DD');
      });
      
      console.log('All dates in month:', allDatesInMonth);
      
      // 3. ดึงข้อมูล timesheet ทุกวันในเดือนนั้น
      const fetchPromises = allDatesInMonth.map(date =>
        this.timesheetService.findTimesheetByDate(this.maintimesheetId, date).toPromise()
      );
      
      Promise.all(fetchPromises).then((results) => {
        const allBackendTimesheets: any[] = [];
        results.forEach((result) => {
          if (Array.isArray(result)) {
            allBackendTimesheets.push(...result);
          } else if (result) {
            allBackendTimesheets.push(result);
          }
        });
        
        console.log('All backend timesheets in this month:', allBackendTimesheets);
        
        // 4. รวบรวม projectId และ manday ที่จะใช้ (หลังจาก update)
        const projectMandayMap = new Map<number, number>();
        
        // 4.1 นับจาก backend timesheets ทั้งหมด
        allBackendTimesheets.forEach(ts => {
          if (ts && ts.id && ts.projectId && ts.workingHours > 0) {
            // ถ้าเป็น timesheet ที่กำลังจะ update ให้ข้ามไป (จะนับจาก timesheet ใหม่แทน)
            if (ts.id === this.timesheet.id) {
              console.log(`Skipping current editing timesheet ID ${ts.id}`);
              return;
            }
            
            const currentManday = projectMandayMap.get(ts.projectId) || 0;
            projectMandayMap.set(ts.projectId, currentManday + (ts.workingHours / 8));
            console.log(`Added existing timesheet ID ${ts.id}: ${ts.workingHours / 8} manday for project ${ts.projectId}`);
          }
        });
        
        // 4.2 เพิ่ม manday จาก timesheet ที่กำลังจะ update
        if (this.timesheet.projectId && this.timesheet.workingHours > 0) {
          const currentManday = projectMandayMap.get(this.timesheet.projectId) || 0;
          projectMandayMap.set(this.timesheet.projectId, currentManday + (this.timesheet.workingHours / 8));
          console.log(`Added updated timesheet ID ${this.timesheet.id}: ${this.timesheet.workingHours / 8} manday for project ${this.timesheet.projectId}`);
        }
        
        console.log('Final Project Manday Map:', projectMandayMap);
        
        // ถ้าไม่มี project ที่ต้องเช็ค
        if (projectMandayMap.size === 0) {
          this.performUpdate();
          return;
        }
        
        // 5. เตรียม requests สำหรับเช็ค remaining manday
        const requests: any[] = [];
        const projectIds: number[] = [];
        
        projectMandayMap.forEach((manday, projectId) => {
          projectIds.push(projectId);
          requests.push(
            this.projectService.getProjectRemainingManday(projectId).pipe(
              map((projectData) => ({
                ...projectData,
                projectManday: manday
              }))
            )
          );
        });
        
        // 6. เช็ค Manday
        forkJoin(requests).subscribe(
          (results) => {
            this.projectRemainingManday = results;
            console.log('Project Remaining Manday:', this.projectRemainingManday);
            
            let hasError = false;
            const noInitialMandayProjects = [];
            
            for (const element of this.projectRemainingManday) {
              const {
                id,
                projectName,
                manday,
                remainingManday,
                projectManday,
                countmanday
              } = element;
              
              const actualRemaining = remainingManday ?? manday;
              const calManday = actualRemaining - projectManday;
              
              console.log(`Project ${projectName}: countmanday=${countmanday}, manday=${manday}, actualRemaining=${actualRemaining}, projectManday=${projectManday}, calManday=${calManday}`);
              
              // เช็คว่า Manday เกินหรือไม่
              if (
                ((manday == null || manday > 0) && calManday != null && calManday < 0) ||
                (countmanday === 'T' && manday == null)
              ) {
                hasError = true;
                noInitialMandayProjects.push({
                  id,
                  projectName,
                  projectManday,
                  calManday: countmanday === 'T' && manday == null ? projectManday * -1 : calManday,
                });
              }
            }
            
            if (hasError) {
              // แสดง Error Message
              let errorMessage = `
                <div style="text-align: center;">
                  ${noInitialMandayProjects
                    .map((p) => `${p.projectName}: ${p.calManday} manday`)
                    .join("<br>")}
                </div>
              `;
              
              Swal.fire({
                target: document.getElementById("form-modal"),
                icon: "error",
                title: "Project Manday is not enough",
                html: errorMessage,
                confirmButtonText: "OK",
              }).then(() => {
                console.log('User acknowledged manday error');
              });
              
              return;
            }
            
            // ถ้าไม่มี error ให้ดำเนินการ update
            this.performUpdate();
          },
          (error) => {
            console.error('Error checking manday:', error);
            Swal.fire({
              target: document.getElementById("form-modal"),
              title: 'Error',
              text: 'Unable to check project manday. Please try again.',
              icon: 'error',
              confirmButtonText: 'OK',
            });
          }
        );
        
      }).catch((error) => {
        console.error('Error fetching all timesheets:', error);
        Swal.fire({
          target: document.getElementById("form-modal"),
          title: 'Error',
          text: 'Unable to load timesheet data. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      });
      
    },
    (error) => {
      console.error('Error finding main timesheet:', error);
      Swal.fire({
        target: document.getElementById("form-modal"),
        title: 'Error',
        text: 'Unable to load main timesheet data. Please try again.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
    }
  );
}
 // ========== แก้ไขฟังก์ชัน performUpdate() ใน popup-edit.component.ts ==========

performUpdate() {
  if (this.timesheet.checkOnsite && this.timesheet.siteId !== null && this.timesheet.siteId !== undefined) {
    // ✅ ใช้ combinedSites แทน selectedProject.msProjectSites
    if (this.combinedSites?.length > 0) {
      const selectedSite = this.combinedSites[this.timesheet.siteId];
      
      if (selectedSite) {
        this.timesheet.siteName = selectedSite.siteName;
        this.timesheet.cost = Number(selectedSite.siteCost) || 0;

        // ✅ ส่งทั้ง id และ siteId เพื่อให้ backend มีตัวเลือกในการค้นหา
        (this.timesheet as any).projectSites = [{
          id: selectedSite.id || selectedSite.siteId,          // PK ของ MsProjectSite
          siteId: selectedSite.id || selectedSite.siteId,      // ส่งซ้ำเพื่อความแน่ใจ
          siteName: selectedSite.siteName,
          siteCost: selectedSite.siteCost,
          projectId: selectedSite.projectId || this.timesheet.projectId
        }];
        
        console.log("✅ Sending site data:", (this.timesheet as any).projectSites);
      } else {
        this.timesheet.siteId = null;
        this.timesheet.siteName = null;
        this.timesheet.cost = null;
        (this.timesheet as any).projectSites = [];
      }
    }
  } else {
    // ไม่ใช่ onsite
    this.timesheet.siteId = null;
    this.timesheet.siteName = null;
    (this.timesheet as any).projectSites = [];

    if (!this.timesheet.checkOnsite) {
      this.ChangeValueCost(this.timesheet.projectId);
    } else {
      this.timesheet.cost = null;
    }
  }

  this.timesheet.updatedBy = localStorage.getItem("fname");

  console.log("🚀 Sending timesheet data:", {
    id: this.timesheet.id,
    projectId: this.timesheet.projectId,
    checkOnsite: this.timesheet.checkOnsite,
    siteId: this.timesheet.siteId,
    siteName: this.timesheet.siteName,
    projectSites: (this.timesheet as any).projectSites
  });

  this._service.updateTimesheetToRemote(this.timesheet)
    .subscribe(
      (data) => {
        if (data != false) {
          const updatedSiteData = {
            timesheetId: this.timesheet.id,
            siteName: this.timesheet.siteName,
            cost: this.timesheet.cost,
            checkOnsite: this.timesheet.checkOnsite,
            description: this.timesheet.description,
            timestamp: new Date().getTime()
          };
          sessionStorage.setItem(`timesheet_${this.timesheet.id}`, JSON.stringify(updatedSiteData));
          
          Swal.fire({
            title: "Success!",
            text: "Timesheet updated successfully.",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.propModal.close("updated");
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Failed to update timesheet.",
            icon: "error",
            confirmButtonText: "OK"
          });
        }
      },
      (error) => {
        console.error("❌ Error saving timesheet:", error);
        Swal.fire({
          title: "Error!",
          text: "An error occurred while saving: " + (error.error?.message || error.message || 'Unknown error'),
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    );
}

  gotolist() {}

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  popupTime(content: any) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        windowClass: "zinfexFixed",
      })
      .result.then(
        (res) => {
          this.closeModal = `Closed with: ${res}`;
        },
        (res) => {
          this.closeModal = `Dismissed ${this.getDismissReason(res)}`;
        }
      );
  }

  funcCloseMOdel(modal: any) {
    modal.close("Back click");
  }

  changValueStart(e: any) {
    this.houreStart = e.target.value;
    this.checkTimeOverlap();
  }

  changValueEnd(e: any) {
    this.minuteEnd = e.target.value;
    this.checkTimeOverlap();
  }

  funcCloseMOdelEnd(modal: any) {
    modal.close("Back click");
  }

  changValueStartEnd(e: any) {
    this.houreStartEnd = e.target.value;
  }

  changValueEndTime(e: any) {
    this.minuteEndEnd = e.target.value;
  }

 

  checkIfLeaveEntry() {
    if (this.timesheet && this.timesheet.projectId && this.allProjects.length > 0) {
      const selectedProject = this.allProjects.find(p => p.id === this.timesheet.projectId);
      if (selectedProject) {
        this.isLeaveEntry = selectedProject.projectCode && /^L(10|[1-9])$/.test(selectedProject.projectCode);
      }
    }
  }

  getSelectedProjectName(): string {
    if (!this.timesheet.projectId) return '';
    const project = this.allProjects.find(p => p.id === this.timesheet.projectId);
    return project ? project.projectName : '';
  }

  getSelectedIsSiteActive(): boolean {
    if (!this.timesheet.projectId) return false;
    const project = this.allProjects.find(p => p.id === this.timesheet.projectId);
    return project.isSiteActive == 'Y' ? true : false
  }

  deleteTimesheet(id: number) {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this._service.deleteTimesheetByIdFromRemote(id).subscribe(
          (success) => {
            Swal.fire("Deleted!", "Your timesheet has been deleted.", "success");
            this.propModal.close("deleted");
            window.location.reload();
          },
          (success) => {
            Swal.fire("Deleted!", "Your timesheet has been deleted.", "success");
            this.propModal.close("deleted");
            window.location.reload();
          }
        );
      }
      return false;
    });
  }



// ========== เพิ่มใน Interface และ Property ==========

// เพิ่ม property นี้ใน class
combinedSites: any[] = [];

// ========== แก้ไขฟังก์ชัน getData() ==========

getData() {
  this._service.fetchTimesheetTByIdFromRemote(this.timeId).subscribe(
    (data) => {
      this.timesheet = data;
      console.log("=== Loading timesheet data ===");
      console.log("timesheetId =========", this.timesheet);

      this.checkIfLeaveEntry();

       setTimeout(() => {
        this.resizeAllTextareas();
      }, 100);

      const timesheetData = data as any;

      if (timesheetData.projectSites && timesheetData.projectSites.length > 0) {
        this.timesheet.siteName = timesheetData.projectSites[0].siteName;
        if (timesheetData.projectSites[0].siteCost) {
          this.timesheet.cost = Number(timesheetData.projectSites[0].siteCost) || 0;
        }
      }

      this.tmpTimeFrom = moment(this.timesheet.timeFrom, "HH:mm").format("HH:mm");
      this.tmpTimeTo = moment(this.timesheet.timeTo, "HH:mm").format("HH:mm");

      if (this.timesheet.projectId) {
        const selectedProject = this.projects.find(p => p.id === this.timesheet.projectId);
        
        // ✅ อัพเดท combinedSites ก่อน
        this.updateSelectedProjectSites();

        if (this.combinedSites.length > 0) {
          if (this.timesheet.siteName) {
            // 🔍 ค้นหา site จาก siteName หรือ siteId
            let foundSiteIndex = -1;
            
            // ลองค้นหาจาก siteId ก่อน (ถ้ามี)
            if (this.timesheet.siteId) {
              foundSiteIndex = this.combinedSites.findIndex(
                site => (site.id || site.siteId) === this.timesheet.siteId
              );
            }
            
            // ถ้าไม่เจอ ค้นหาจาก siteName
            if (foundSiteIndex < 0) {
              foundSiteIndex = this.combinedSites.findIndex(
                site => site.siteName?.trim() === this.timesheet.siteName?.trim()
              );
            }

            if (foundSiteIndex >= 0) {
              // ✅ เจอ site ที่เลือกไว้
              this.timesheet.siteId = foundSiteIndex;
              const selectedSite = this.combinedSites[foundSiteIndex];
              this.timesheet.siteName = selectedSite.siteName;
              this.timesheet.cost = Number(selectedSite.siteCost) || 0;
              console.log("✅ Found and selected site:", selectedSite);
            } else {
              // ไม่เจอ site ที่เลือกไว้
              console.warn("⚠️ Site not found:", this.timesheet.siteName);
              this.timesheet.siteId = null;
              this.timesheet.siteName = null;
            }
          } else if (this.timesheet.checkOnsite) {
            // onsite แต่ไม่มี site เลือก
            this.timesheet.siteId = null;
            this.timesheet.siteName = null;
          } else {
            this.timesheet.siteId = null;
          }
        } else {
          // ไม่มี sites ให้เลือก
          this.timesheet.siteId = null;
          this.timesheet.siteName = null;
        }
      }
      
      this.getCost(this.timesheet.projectId);
      if (!this.timesheet.checkOnsite) {
        this.ChangeValueCost(this.timesheet.projectId);
      }

      this.tmpDate = moment(this.timesheet.transDate, "YYYY-MM-D")
        .subtract(-1, "days")
        .toDate();
      this.maintimesheetId = this.timesheet.mainTimesheetId;
      this.getRefProject(this.timesheet);

      this.checkIfLeaveEntry();
    },
    (error) => console.log("exception occurred")
  );
}

// ========== เพิ่มฟังก์ชันใหม่: getCombinedSites() ==========

/**
 * รวม sites จากทุก project (เรียงแบบเดียวกับ add-my-popup)
 * - Sites ของ project ปัจจุบันขึ้นก่อน
 * - Sites ของ project อื่นๆ ตามหลัง (เรียง A-Z)
 */
getCombinedSites(): any[] {
  const selectedProject = this.projects.find(p => p.id === this.timesheet.projectId);
  
  if (!selectedProject) {
    return [];
  }

  // รวบรวม sites จากทุก project
  const allSites = this.projects.reduce((acc, project) => {
    if (project.msProjectSites && project.msProjectSites.length > 0) {
      return [...acc, ...project.msProjectSites];
    }
    return acc;
  }, []);

  // กรอง sites ที่ไม่ซ้ำกัน (ตาม id หรือ siteId)
  const uniqueSites = allSites.filter((site, index, self) =>
    index === self.findIndex((s) => 
      (s.id || s.siteId) === (site.id || site.siteId)
    )
  );

  // แยก sites ของ project ที่เลือก และ project อื่นๆ
  const currentProjectSites = selectedProject.msProjectSites || [];
  const otherProjectSites = uniqueSites.filter((site) => 
    !currentProjectSites.find((cs) => 
      (cs.siteId) === (site.id || site.siteId)
    )
  );

  // เรียง sites ของ project อื่นๆ ตาม siteName A-Z
  otherProjectSites.sort((a, b) => 
    (a.siteName || '').localeCompare(b.siteName || '')
  );

  // รวม: sites ของ project ปัจจุบันก่อน + sites อื่นๆ
  return [...currentProjectSites, ...otherProjectSites];
}

// ========== แก้ไขฟังก์ชัน updateSelectedProjectSites() ==========

updateSelectedProjectSites() {
  const project = this.projects.find(p => p.id === this.timesheet.projectId);
  
  // ✅ ใช้ getCombinedSites แทน
  this.combinedSites = this.getCombinedSites();
  
  console.log("combinedSites updated:", this.combinedSites);

  // ถ้า onsite แต่ยังไม่มี site เลือก และมี sites ให้เลือก
  if (this.timesheet.checkOnsite && !this.timesheet.siteName && this.combinedSites.length > 0) {
    this.timesheet.siteId = null;
  }
}

// ========== แก้ไขฟังก์ชัน ChangeValueCost() ==========

ChangeValueCost(id: any) {
  const costbyId = this.projects.find((item) => item.id === id);
  const siteCost = costbyId?.msProjectSites?.[0]?.siteCost;

  if (siteCost && Number(siteCost) > 0) {
    this.timesheet.cost = Number(siteCost);
    this.selectedProjectCost = this.timesheet.cost;
  } else {
    this.timesheet.cost = null;
    this.selectedProjectCost = null;
  }

  // ✅ อัพเดท combinedSites เมื่อเปลี่ยน project
  this.updateSelectedProjectSites();
  

  this.timesheet.checkOnsite = false;
  this.timesheet.siteId = null;
  this.timesheet.siteName = null;
}

// ========== แก้ไขฟังก์ชัน onSiteChange() ==========

onSiteChange(siteIndex: number) {
  if (siteIndex === null || siteIndex === undefined) {
    this.timesheet.siteName = null;
    this.timesheet.cost = null;
    return;
  }

  // ✅ ใช้ combinedSites แทน selectedProjectSites
  if (!this.combinedSites?.length) {
    this.timesheet.siteName = null;
    this.timesheet.cost = null;
    return;
  }

  const selectedSite = this.combinedSites[siteIndex];

  if (selectedSite) {
    this.timesheet.siteId = siteIndex;
    this.timesheet.siteName = selectedSite.siteName;
    this.timesheet.cost = Number(selectedSite.siteCost) || 0;
    console.log("✅ Site changed to:", selectedSite);
  } else {
    this.timesheet.siteId = null;
    this.timesheet.siteName = null;
    this.timesheet.cost = null;
  }
}

// ========== สำหรับ HTML Template - แก้จาก selectedProjectSites เป็น combinedSites ==========

/*
เปลี่ยนในไฟล์ HTML จาก:

<select class="form-control" [(ngModel)]="timesheet.siteId" name="siteSelection"
  (change)="onSiteChange(timesheet.siteId)" [disabled]="isLeaveEntry">
  <option [value]="null" disabled>Select Site</option>
  <option *ngFor="let site of selectedProjectSites; let i = index" [ngValue]="i">
    {{ site.siteName }} <ng-container *ngIf="site.siteCost">-- {{ site.siteCost }}</ng-container>
  </option>
</select>

เป็น:

<select class="form-control" [(ngModel)]="timesheet.siteId" name="siteSelection"
  (change)="onSiteChange(timesheet.siteId)" [disabled]="isLeaveEntry">
  <option [value]="null" disabled>Select Site</option>
  <option *ngFor="let site of combinedSites; let i = index" [ngValue]="i">
    {{ site.siteName }} <ng-container *ngIf="site.siteCost">-- {{ site.siteCost | currency:'THB ':'symbol':'1.0-0' }}</ng-container>
  </option>
</select>
*/
}